export default __webpack_public_path__ + "static/media/windIcon.7541ab92.svg";